module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multi-step__header"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('span', {
      class: {
        'is-active': _vm.currentstep === (index + 1)
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e23c353a!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/multi-steps/Navigation.vue
// module id = 764
// module chunks = 1